// 🌐 Configuration de l'API backend PHP/MySQL
// Utilise un chemin relatif pour le déploiement sur le même domaine

const API_BASE_URL = "/api";

export default API_BASE_URL;
